'use client';

import Link from 'next/link';
import { storefrontUrl } from '@utils/storefront-url';
import { trackEvent } from '../../lib/analytics/posthog';
import { EVENTS } from '../../lib/analytics/events';

/** Para profesionales: qué ganan al sumarse, con un negocio genérico (nunca uno real). */
export default function ProsBlock() {
  return (
    <section className="home-section home-section--pros" aria-labelledby="pros-title">
      <div className="home-wrap">
        <div className="pros2">
          <div className="pros2__copy">
            <p className="pros__eyebrow">Para profesionales</p>
            <h2 id="pros-title" className="pros2__title font-display">
              Tu trabajo, a la vista de tu barrio.
            </h2>
            <p className="pros__text">
              <span className="md:hidden">Subí fotos, poné tus precios y aparecé en el mapa con tu anillo de Ágora.</span>
              <span className="hidden md:inline">
                Subí fotos de lo que hacés, poné tus precios y aparecé en el mapa con tu anillo de Ágora.
              </span>
            </p>
            <div className="pros__actions">
              <Link
                href="/signup"
                className="pros2__btn pros2__btn--light"
                onClick={() => trackEvent(EVENTS.HOME_CTA_CLICKED, { cta: 'comenzar_gratis', section: 'pros' })}
              >
                Crear mi perfil gratis
              </Link>
              <a
                href={storefrontUrl('/funcionalidades', { campaign: 'pro_cta', content: 'conocer_mas' })}
                target="_blank"
                rel="noopener noreferrer"
                className="pros2__btn pros2__btn--ghost hidden md:inline-flex"
                onClick={() => trackEvent(EVENTS.HOME_CTA_CLICKED, { cta: 'conocer_mas', section: 'pros' })}
              >
                Ver funcionalidades
              </a>
            </div>
          </div>
          <div className="pros2__demo" aria-hidden="true">
            <span className="pros2__ring">
              <span>Tu foto</span>
            </span>
            <span className="pros2__tag">
              <b>Tu servicio</b>
              <span>tu precio · tu duración</span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
